import script from "./HospitalDoctors.vue?vue&type=script&setup=true&lang=ts"
export * from "./HospitalDoctors.vue?vue&type=script&setup=true&lang=ts"

import "./HospitalDoctors.vue?vue&type=style&index=0&id=86b8410e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86b8410e"]])

export default __exports__